import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-ink-900 py-16 sm:py-20" aria-labelledby="guarantee-title" style={{
    paddingBottom: "0px",
    paddingTop: "5px"
  }} data-id="element-94" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5" data-id="element-95" data-mp="9t1lj1da838w">
        <div className="rounded-3xl border border-success/30 bg-ink-700 p-8 text-center sm:p-12" data-id="element-96" data-mp="etz43f27ezax">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-success" strokeWidth={1.5} aria-hidden="true" data-id="element-97" data-mp="jt294zi6p5iw" />
          <h2 id="guarantee-title" className="mt-5 font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-98" data-mp="ntcfid9w1xya">
            7-Day Guarantee — No Questions Asked
          </h2>
          <p className="mt-5 text-lg text-lilac-200" data-id="element-99" data-mp="xjxkqjk2i0q6">
            Open the volumes. Apply the protocols.
          </p>
          <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-body" data-id="element-100" data-mp="12jjyqv7pzl01">
            If within 7 days this is not exactly what you expected: 100% refund · No forms
            · No drama · No explanation needed.
          </p>
          <p className="mt-6 inline-flex rounded-full bg-success/10 px-4 py-2 text-sm font-bold text-success" data-id="element-101" data-mp="25ti2uao7o8vs">
            Return rate: less than 1%
          </p>
        </div>
      </div>
    </section>;
}